import { createTheme } from '@mui/material/styles'

import Colors from './colors'

const components = {
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: Colors.common.white,
        opacity: 0.2,
      },
    },
  },
  MuiStack: {
    styleOverrides: {
      root: {
        backgroundColor: Colors.brand.dark,
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: Colors.common.white,
        textDecoration: 'underline',
        textDecorationColor: Colors.common.white,

        '&:visited': {
          color: Colors.common.white,
          textDecorationColor: Colors.common.white,
        },
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: Colors.common.white,
      },
    },
  },
}

export default createTheme({
  components,
})
